import smartSpaceApartment from '@/assets/img/users-cases/smart-space-apartment.webp';
import smartSpaceApartmentHow from '@/assets/img/users-cases/smart-space-apartment-how.webp';
import smartSpaceApartmentResult from '@/assets/img/users-cases/smart-space-apartment-result.webp';

export default {
  slug: 'smart-space-apartment',
  order: 15,
  title: '3D Smart Apartment',
  subtitle: 'Smart apartment layouts with 2D plans and 3D views',
  tags: ['Apartmentfloorplans', 'Apartmentlayouts'],

  images: {
    hero: smartSpaceApartment,
    aboutTop: smartSpaceApartmentHow,
    aboutBottom: smartSpaceApartmentResult,
  },

  howText:
    'We developed 2D and 3D apartment floor plans designed to support marketing needs, working out flexible apartment layouts, clear zoning, and furniture scenarios for presentations.',

  resultText:
    'Ready-to-use 2D and 3D materials help developers and marketing agencies roll out marketing assets faster and speed up approvals with investors.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
